import MatchConfigBuilder from './MatchConfigBuilder';

export default MatchConfigBuilder;